import template from './index.html'
import ko from 'knockout'
import treenode from './treenode'
import {validatemixin} from '../../mixin'
import Common from '../poptip/common'
import _ from '@/util/lodash'

const PREFIX = 'y-'
ko.components.register(PREFIX + treenode.name, {
  viewModel: treenode.init,
  template: treenode.template
})
function init (params) {
  validatemixin.call(this, params)
  this.data = params.data
  this.height = params.height || 'auto'
  this.hideNodeCheckStyle = params.hideNodeCheckStyle || false
  debugger
  this.minHeight = params.minHeight || '0'
  this.loadData = params.loadData
  this.nameField = params.nameField
  this.extraEdit = params.extraEdit
  this.extraText = params.extraText
  this.multiple = params.multiple || false
  this.selectedItem = params.selectedItem || (this.multiple ? ko.observableArray() : ko.observable({}))
  this.keyWord = ko.observable()
  this.searchAble = params.searchAble ? params.searchAble : ko.observable(false)
  if (!this.multiple) {
    if (ko.isObservableArray(this.selectedItem)) {
      throw new Error('y-tree: selectedItem should be ko.observableArray while multiple = true')
    }
  }
  this.nodeOption = params.nodeOption || {
    showCheck: '', // 用来判断是否显示check节点的函数
    nodeIcon: '' // 用来动态显示Icon的函数
  }
  this.selectedId = params.selectedId || (this.multiple ? ko.observableArray() : ko.observable())
  this.selectedItem.subscribe(val => {
    if (params.onChange) {
      params.onChange(val)
    }
    // validate校验 用于通知父容器校验信息
    this.judgeValidate(val.id)
  })

  // 树 -> 数组
  this.treeConvertToArr = (tree) => {
    const a = _.cloneDeep(tree) // 深拷贝一下
    let arrs = []
    let result = []
    arrs = arrs.concat(a)
    while (arrs.length) {
      let first = arrs.shift() // 弹出第一个
      if (first.children) {
        arrs = arrs.concat(first.children)
        delete first["children"]
      }
      result.push(first)
    }
    return result
  }

  this.onEnterClick = (data, event) => {
    var e = event || window.event
    var flatData = this.treeConvertToArr(this.data())
    if (e.keyCode === 13) {
      var key = this.keyWord() // 搜索框值
      if (!this.keyWord()) {
        return Common.toastr().error("请输入分类关键词") // 有问题，暂时放着
      }
      var result = []
      flatData.forEach(function (item) {
        if (item.name.indexOf(key.trim()) !== -1) { // 检索到，取其id
          result.push(item.id);
        }
      })
      this.getSearchResult(result)
    }
  }

  this.getSearchResult = (data) => {
    var result = []
    var flatData = this.treeConvertToArr(this.data())
    var newData = _.cloneDeep(flatData)
    var newTreeData = _.cloneDeep(this.data()) // this.data() -> 初始的树
    for (var i = 0; i < data.length; i++) {
      result = result.concat(this.getParentTreeNode(newTreeData, data[i]));
    }
    result = result.map(function (item) { return item.id })
    newData.forEach(function (node) {
      if (result.indexOf(node.id) >= 0) {
        node._expand(true)
      } else {
        node._expand(false)
      }
    });
  }
  this.getParentTreeNode = (data2, nodeId2) => {
    var arrRes = [];
    if (data2.length === 0) {
      if (nodeId2) { // 检索的内容有值
        arrRes.unshift(data2);
      }
      return arrRes;
    }
    var recursion = function (data, nodeId) { // 递归根据子节点反查父节点
      for (var i = 0; i < data.length; i++) {
        var node = data[i];
        if (node.id === nodeId) {
          arrRes.unshift(node);
          recursion(data2, node.parentId);
          break;
        } else {
          if (node.children) {
            recursion(node.children, nodeId);
          }
        }
      }
      return arrRes;
    };
    arrRes = recursion(data2, nodeId2);
    return arrRes;
  }
}
export default {
  name: 'tree',
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/tree/index.js